var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-agency-building-submenu'),_c('v-row',{staticClass:"mx-5",attrs:{"justify":"space-between","align":"stretch","id":"EverPlans"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('q-agent-directory-table',{attrs:{"title":"Agent Directory"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }